export const polygonIdentityConfig = {
  webDomain: 'tangibl3.net',
  webUrl: 'https://tangibl3.net',
  namespace: '.tangiblenet',
  web3Tld: 'tangiblenet',
  chain: {
    mainnetName: 'Polygon PoS',
    mainnetChainId: 137,
    testnetName: 'Polygon Amoy',
    testnetChainId: 80002,
  },
  env: {
    registryContract: 'REACT_APP_TLD_REGISTRY_CONTRACT_ADDRESS',
    certificateFactory: 'REACT_APP_CERTIFICATE_FACTORY_CONTRACT_ADDRESS',
  },
  identityStates: ['Reserved', 'Pending KYB', 'Mintable', 'Minted', 'Suspended'],
  examples: [
    'issuername.tangiblenet',
    'note2026.issuername.tangiblenet',
    'warrant-panama-001.tangiblenet',
  ],
  disclaimer:
    'tangibl3.net is the conventional web domain. .tangiblenet is the Polygon Web3 TLD / identity namespace. A .tangiblenet identity is an identity pointer and registry object. It is not the legal instrument, not proof of asset ownership, and not a guarantee of compliance or liquidity.',
};
